import React from 'react';
import {
  Route,
  Switch
} from 'react-router-dom'
import { PAGE_PATHS } from './constant';
import SubscriptionsPage from './pages/Subscriptions';
import SubscribersPage from './pages/Subscribers';
import './assets/css/styles.scss';
import EmailLogin from './pages/Subscribers/EmailLogin';
import PaymentHistory from './pages/Subscribers/PaymentHistory';
import ArchivesPage from './pages/Archives';
import PrivateRoute from './components/PrivateRoute';
import SubscribeResult from './pages/Subscriptions/SubscribeResult';



function App() {
  return (
      <Switch>
        <Route exact path={`${PAGE_PATHS.SUBSCRIPTIONS}/:listId`} component={SubscriptionsPage}/>
        <Route exact path={`${PAGE_PATHS.SUBSCRIPTIONS}/:listId/result`} component={SubscribeResult}/>
        <Route exact path={`${PAGE_PATHS.ARCHIVES}/:listId`} component={ArchivesPage}/>
        <Route exact path={`${PAGE_PATHS.SUBSCRIBERS_LOGIN}/:listId`} component={EmailLogin}/>
        <PrivateRoute exact path={`${PAGE_PATHS.SUBSCRIBERS_MODIFY}/:listId/:email`} >
          <Route exact path={`${PAGE_PATHS.SUBSCRIBERS_MODIFY}/:listId/:email`} component={SubscribersPage}/> 
        </PrivateRoute>
        {/* <Route exact path={`${PAGE_PATHS.SUBSCRIBERS_MODIFY}/:listId/:email`} component={SubscribersPage}/> */}
        <PrivateRoute exact path={`${PAGE_PATHS.SUBSCRIBERS_PAYMENT_HISTORY}/:listId/:email`} >
          <Route exact path={`${PAGE_PATHS.SUBSCRIBERS_PAYMENT_HISTORY}/:listId/:email`} component={PaymentHistory}/>
        </PrivateRoute>
      </Switch>
  );
}

export default App;
